'use client'
import React, { useState, useEffect } from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import { useCustomTheme } from '@/context/ThemeProvider'

export default function ThemeToggle() {
  const { mode, toggleTheme, lightPalette } = useCustomTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Don't render anything until mounted to avoid hydration mismatch
  if (!mounted) {
    return (
      <IconButton
        color="inherit"
        aria-label="Theme toggle"
        sx={{
          ml: 1,
          visibility: 'hidden', // Keep space but hide during SSR
        }}
      >
        <LightModeIcon />
      </IconButton>
    )
  }

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton
        onClick={toggleTheme}
        color="inherit"
        aria-label={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
        sx={{
          ml: 1,
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'rotate(15deg)',
          },
        }}
      >
        {mode === 'light' ? (
          <DarkModeIcon sx={{ color: lightPalette.primary.main }} />
        ) : (
          <LightModeIcon sx={{ color: lightPalette.primary.main }} />
        )}
      </IconButton>
    </Tooltip>
  )
}
